function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.15625 0.671875C0 0.53125 0 0.28125 0.15625 0.140625C0.296875 0 0.53125 0 0.671875 0.140625L3.03125 2.5L5.39062 0.140625C5.54688 0 5.78125 0 5.92188 0.140625C6.07812 0.296875 6.07812 0.53125 5.92188 0.671875L3.5625 3.03125L5.92188 5.39062C6.07812 5.53125 6.07812 5.78125 5.92188 5.92188C5.78125 6.0625 5.54688 6.0625 5.39062 5.92188L3.03125 3.5625L0.671875 5.92188C0.53125 6.0625 0.296875 6.0625 0.15625 5.92188C0 5.78125 0 5.53125 0.15625 5.39062L2.51562 3.03125L0.15625 0.671875Z",
  fill: "white"
});

function SvgCampaignStepClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignStepClose);
export default __webpack_public_path__ + "static/media/campaign-step-close.c1326f95.svg";
export { ForwardRef as ReactComponent };